import React from 'react';
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

function FormHeader(props) {
    return (
        <React.Fragment>
            <Box>
                <Typography variant="h2" component="h1">
                    Program: {props.Title}
                </Typography>
                <Typography variant="h4" component="h2">
                    CLE Hours: {props.CLECredit}
                </Typography>
            </Box>
        </React.Fragment>
    );
}

export default FormHeader;
